/* eslint-disable @typescript-eslint/no-use-before-define */
// @ts-nocheck
import React, { useEffect, useState } from 'react';

import TextArea from 'components/layout/form/textArea';
import TextField from 'components/layout/form/textField';
import api from 'services/api';

import { AiOutlineUser } from 'react-icons/ai';
import { BsChatLeftText } from 'react-icons/bs';
import { FiSmartphone } from 'react-icons/fi';
import { MdOutlineAlternateEmail } from 'react-icons/md';

import { useMediaQuery } from 'react-responsive';
import Loading from 'components/layout/loading';
import BaseSelected from '../../RefuelContainer/components/BaseSelected';

import { useNewRefuel } from '../../hooks/useNewRefuel';

import {
  Container,
  SelectBasesWrap,
  ResposibleDataForm,
  BasesContainer,
  ContainerForm,
  Form,
  Label,
  ResposibleFormHeader,
  ResponsibleDataTitle,
  ResponsibleDataSubTitle,
} from './styles';

const ResponsibleData: React.FC = () => {
  const [name, setName] = useState<string>('');
  const [changedName, setChangedName] = useState<boolean>(false);
  const [phone, setPhone] = useState<string>('');
  const [changedPhone, setChangedPhone] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [changedEmail, setChangedEmail] = useState<boolean>(false);
  const [detail, setDetail] = useState<string>('');
  const [changeDetail, setChangeDetail] = useState<boolean>(false);

  const {
    selectedBases,
    handleResponsible,
    responsibleData,
    isLoading,
    setIsLoading,
  } = useNewRefuel();

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const handleName = (e: any): void => {
    e.preventDefault();
    setName(e.target.value);
    handleResponsible(e.target.value, 'name');
    setChangedName(true);
  };

  const handlePhone = (e: any): void => {
    e.preventDefault();
    setPhone(e.target.value);
    handleResponsible(e.target.value, 'phone');
    setChangedPhone(true);
  };

  const handleEmail = (e: any): void => {
    e.preventDefault();
    setEmail(e.target.value);
    handleResponsible(e.target.value, 'email');
    setChangedEmail(true);
  };

  const handleDetails = (e: any): void => {
    e.preventDefault();
    setDetail(e.target.value);
    handleResponsible(e.target.value, 'details');
    setChangeDetail(true);
  };

  useEffect(() => {
    setName(responsibleData.name);
    setChangedName(true);
    setPhone(responsibleData.phone);
    setChangedPhone(true);
    setEmail(responsibleData.email);
    setChangedEmail(true);
    setDetail(responsibleData.details);
    setChangeDetail(true);
  }, [responsibleData]);

  const requestRefuels = async (): void => {
    setIsLoading(true);
    const tokenParam = localStorage.getItem('@UltragazEmpresarial:accessToken');
    const customerIdParam = localStorage.getItem(
      '@UltragazEmpresarial:customerId'
    );
    const customerSiteIdParam = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteId'
    );

    const header = {
      'Content-Type': 'application/json',
      access_token: tokenParam,
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };

    const url = `/industrial/case/v1/refuels?customer-id=${customerIdParam}&customer-site-id=${customerSiteIdParam}&_limit=10&_offset=0`;

    api
      .get(url, parameters)
      .then((res) => {
        const response = res.data;
        const [dataContact] = response;
        const { contactEmail, contactPhone, contactName } = dataContact;
        if (contactName) {
          setName(contactName);
          handleResponsible(contactName, 'name');
          setChangedName(true);
        }
        if (contactEmail) {
          setEmail(contactEmail);
          handleResponsible(contactEmail, 'email');
          setChangedName(true);
        }
        if (contactPhone) {
          setPhone(contactPhone);
          handleResponsible(contactPhone, 'phone');
          setChangedPhone(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (Object.keys(responsibleData).length === 0) {
      requestRefuels();
    }
  }, [responsibleData]);

  return (
    <>
      {isLoading && <Loading />}
      <Container>
        <SelectBasesWrap>
          <BasesContainer>
            {!isMobile && selectedBases.length > 0 && (
              <>
                {selectedBases.map((base, idx) => (
                  <BaseSelected
                    isComplete
                    baseName={base.name}
                    nickName={base.nickname}
                    address={`${base.address}, ${base.number} - ${base.complement}`}
                  />
                ))}
              </>
            )}
          </BasesContainer>
        </SelectBasesWrap>
        <ResposibleDataForm>
          <ResposibleFormHeader>
            <ResponsibleDataTitle>
              Dados do responsável pelo recebimento
            </ResponsibleDataTitle>
            <ResponsibleDataSubTitle>
              Preencha aqui os dados solicitados de quem irá receber o serviço
              de abastecimento.
            </ResponsibleDataSubTitle>
          </ResposibleFormHeader>
          <ContainerForm>
            <Form>
              <Label>
                <TextField
                  LeadingIcon={() => <AiOutlineUser />}
                  name="name"
                  type="text"
                  label="Nome completo*"
                  aria-label="Nome completo*"
                  errorCondition={changedName && name === ``}
                  errorMessage="Nome obrigatório"
                  title="Nome completo*"
                  onBlur={handleName}
                  placeholder="Nome completo*"
                  value={name}
                  onChange={handleName}
                />
              </Label>
              <Label>
                <TextField
                  LeadingIcon={() => <FiSmartphone />}
                  type="tel"
                  label="Celular com DDD*"
                  aria-label="Celular com DDD*"
                  errorCondition={changedPhone && phone === ''}
                  errorMessage="Telefone obrigatório"
                  title="Celular com DDD*"
                  onBlur={handlePhone}
                  placeholder="Celular com DDD*"
                  value={phone}
                  onChange={handlePhone}
                  mask="(99) 99999-9999"
                  maskChar=" "
                  name="phone"
                />
              </Label>
              <Label>
                <TextField
                  LeadingIcon={() => <MdOutlineAlternateEmail />}
                  type="mail"
                  label="E-mail*"
                  aria-label="E-mail*"
                  errorCondition={changedEmail && email === ''}
                  errorMessage="E-mail obrigatório"
                  title="E-mail*"
                  onBlur={handleEmail}
                  placeholder="E-mail*"
                  value={email}
                  onChange={handleEmail}
                  maskChar="contato@ultragaz.com.br"
                  name="email"
                />
              </Label>
              <Label>
                <TextArea
                  LeadingIcon={() => <BsChatLeftText />}
                  type="text"
                  label="Deixe seu comentário"
                  aria-label="Deixe seu comentário"
                  errorCondition={changeDetail && detail === ''}
                  errorMessage="Campo obrigatório"
                  title="Deixe seu comentário"
                  onBlur={handleDetails}
                  placeholder="Deixe seu comentário"
                  value={detail}
                  onChange={handleDetails}
                  name="detail"
                />
              </Label>
            </Form>
          </ContainerForm>
        </ResposibleDataForm>
      </Container>
    </>
  );
};

export default ResponsibleData;
